import React, { memo, useEffect, useMemo, useState } from 'react'
import { CircleCancelMajor, ClockMajor, CustomerPlusMajor } from '@shopify/polaris-icons'
import { useSelector } from 'react-redux'
import { getOnboardingCounts } from 'src/selectors/onboarding'
import { OnboardingStatus } from 'src/constants/onboarding/enums'
import { OnboardingCounts } from 'src/interfaces/onboarding'
import { colors } from 'src/theme'
import { addS } from 'src/utils/baseUtils'
import { TableTab, TableTabs } from 'src/components/shared/table/table-tabs/TableTabs'

interface Props {
  selectedTab: OnboardingStatus
  onClick(tab: OnboardingStatus): void
}

const OnboardingTabsComponent = ({ selectedTab, onClick }: Props) => {
  const onboardingCounts = useSelector(getOnboardingCounts)
  const [counts, setCounts] = useState<Partial<OnboardingCounts>>()

  useEffect(() => {
    const {
      created,
      partially_completed: partiallyCompleted,
      ...otherCounts
    } = onboardingCounts || {}

    setCounts({
      ...otherCounts,
      [OnboardingStatus.Created]: (created || 0) + (partiallyCompleted || 0),
    })
  }, [onboardingCounts])

  const tabs = useMemo(() => {
    const res: TableTab<OnboardingStatus>[] = [
      {
        value: OnboardingStatus.Created,
        title: 'Invited contractors',
        renderIcon: (selected: boolean) => (
          <CustomerPlusMajor
            width={20}
            height={20}
            fill={selected ? colors.PRIMARY_PURPLE_600 : colors.GRAY_BLACK}
          />
        ),
      },
      {
        value: OnboardingStatus.WaitingForApproval,
        title: 'Waiting for approval',
        renderIcon: (selected: boolean) => (
          <ClockMajor
            width={20}
            height={20}
            fill={selected ? colors.PRIMARY_PURPLE_600 : colors.GRAY_BLACK}
          />
        ),
      },
      {
        value: OnboardingStatus.Failed,
        title: 'Onboarding failed',
        renderIcon: (selected: boolean) => (
          <CircleCancelMajor
            width={20}
            height={20}
            fill={selected ? colors.PRIMARY_PURPLE_600 : colors.GRAY_BLACK}
          />
        ),
      },
    ]

    return res.map((item) => ({
      ...item,
      subtitle: counts
        ? `${counts[item.value] || 0} ${addS(counts[item.value] || 0, 'contractor')}`
        : '',
    }))
  }, [counts])

  return <TableTabs<OnboardingStatus> tabs={tabs} selectedValue={selectedTab} onClick={onClick} />
}

export const OnboardingTabs = memo(OnboardingTabsComponent)
